<template>
   <div class="main-container">
      <img alt="img" class="bg-home" src="@/assets/images/img-bg-unitel.svg" />
      <home-navbar
         :activeFTTH="activeFTTH"
         :isLinkedFTTH="isLinkedFTTH"
         :user="user"
         @onClickFTTHTab="onClickFTTHTab"
         @onClickFunction="onClickFunction"
         @onClickMobileTab="onClickMobileTab"
         @redirectTo="redirectTo"
         @show-account="handleLoadAccountInfo"
      />
      <div ref="homeContent">
         <template v-if="activeFTTH">
            <home-ftth-data
               :ftthTab="ftthTab"
               :isLinkedFTTH="isLinkedFTTH"
               :user="user"
               @authen="authen"
               @onClickTab="onClickTab"
               @onPay="onPay"
               @login="handleAuthen"
            />
         </template>
         <template v-else>
            <transition name="slide">
               <home-account-data
                  v-show="isShowAccountInfo"
                  :accountInfo="accountInfo"
                  :sub-type="subType"
                  :user="user"
                  @onClickFunction="onClickFunction"
                  @redirectTo="redirectTo"
               />
            </transition>
         </template>
         <!-- <template v-if="!activeFTTH"> -->
         <template v-if="false">
            <div v-for="(item, i) in lstNoti" :key="i">
               <!-- && item.isDeleteCH -->
               <template v-if="item.type == '3GRAB' && item.isDeleteCH">
                  <div class="noti-custom">
                     <span class="noti-custom__action">
                        <i class="icon-fonts icon-fonts--close" @click="deleteNoti(item.type)"></i>
                     </span>
                     <div class="noti-custom__detail" @click="onClickFunction('/laokyc')">
                        <span class="noti-custom__icon"><i class="icon-fonts icon-fonts--notice"></i></span>
                        <div class="noti-custom__info">
                           <p class="noti-custom__name">{{ item.title }}</p>
                        </div>
                     </div>
                  </div>
               </template>
               <template v-if="item.type == 'BALANCE' && item.isDeleteBalance">
                  <div class="noti-custom">
                     <span class="noti-custom__action"
                        ><i class="icon-fonts icon-fonts--close" @click="deleteNoti(item.type)"></i
                     ></span>
                     <div class="noti-custom__detail">
                        <span class="noti-custom__icon"><i class="icon-fonts icon-fonts--notice"></i></span>
                        <div class="noti-custom__info">
                           <h5 class="noti-custom__name">{{ $t('home.noti.notice') }}: {{ item.title }}</h5>
                           <p class="noti-custom__des">{{ item.des }}</p>
                           <div class="noti-custom__btn">
                              <button class="button button--orange button--small" @click="redirectMobileRecharge()">
                                 {{ $t('home.noti.recharge') }}
                                 <!-- <a href="/mobile/recharge">{{$t('home.noti.recharge')}}</a> -->
                              </button>
                              <button
                                 class="button button--yellow button--small"
                                 style="cursor: pointer"
                                 @click="redirectMobileBorrow()"
                              >
                                 {{ $t('home.noti.borrow') }}
                                 <!-- <a href="/mobile/credit-service">{{$t('home.noti.borrow')}}</a> -->
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </template>
               <template v-if="item.type == 'DATA' && item.isDeleteData">
                  <div class="noti-custom">
                     <span class="noti-custom__action"
                        ><i class="icon-fonts icon-fonts--close" @click="deleteNoti(item.type)"></i
                     ></span>
                     <div class="noti-custom__detail">
                        <span class="noti-custom__icon"><i class="icon-fonts icon-fonts--notice"></i></span>
                        <div class="noti-custom__info">
                           <h5 class="noti-custom__name">{{ $t('home.noti.notice') }}: {{ item.title }}</h5>
                           <p class="noti-custom__des">{{ item.des }}</p>
                        </div>
                     </div>
                     <ul class="noti-list">
                        <template v-if="lstCurrentUsedSubServices && lstCurrentUsedSubServices.length != 0">
                           <li class="noti-list__item orange" @click="selectPack(lstCurrentUsedSubServices[0])">
                              <span class="noti-list__badge"
                                 ><span>{{ $t('home.noti.recently') }}</span></span
                              >
                              <h5 class="noti-list__name">{{ lstCurrentUsedSubServices[0].name }}</h5>
                              <div class="noti-list__info">
                                 <span class="noti-list__value">{{
                                    lstCurrentUsedSubServices[0].des.split('=')[0]
                                 }}</span>
                                 <span class="noti-list__value">{{
                                    lstCurrentUsedSubServices[0].des.split('=')[1]
                                 }}</span>
                              </div>
                           </li>
                        </template>
                        <template v-if="lstServiceBestSeller && lstServiceBestSeller.length != 0">
                           <li class="noti-list__item yellow" @click="selectPack(lstServiceBestSeller[0])">
                              <span class="noti-list__badge"
                                 ><span>{{ $t('home.noti.best_seller') }}</span></span
                              >
                              <h5 class="noti-list__name">
                                 {{
                                    lstServiceBestSeller[0].name
                                       ? lstServiceBestSeller[0].name
                                       : lstServiceBestSeller[0].code
                                 }}
                              </h5>

                              <div class="noti-list__info">
                                 <span class="noti-list__value">{{
                                    lstServiceBestSeller[0].des && lstServiceBestSeller[0].des.split('=')[0]
                                       ? lstServiceBestSeller[0].des.split('=')[0]
                                       : lstServiceBestSeller[0].des
                                 }}</span>
                                 <span class="noti-list__value">{{
                                    lstServiceBestSeller[0].des && lstServiceBestSeller[0].des.split('=')[1]
                                       ? lstServiceBestSeller[0].des.split('=')[1]
                                       : lstServiceBestSeller[0].des
                                 }}</span>
                              </div>
                           </li>
                        </template>
                        <li class="noti-list__item brown" @click="borrowData">
                           <span class="noti-list__action"><i class="icon-fonts icon-fonts--add"></i></span>
                           <div class="noti-list__info">
                              <span class="noti-list__value">{{ $t('home.noti.borrow_data') }}</span>
                           </div>
                        </li>
                     </ul>
                  </div>
               </template>
            </div>
         </template>
         <main-functions
            v-if="!activeFTTH || isLinkedFTTH || isLoggedIn"
            :favouriteList="favouriteList"
            :ftthList="ftthList"
            @redirectToMobileFunc="redirectToMobileFunc"
         >
            <!-- <hr class="line" />   -->
            <!-- <home-data-package /> -->
            <!-- <hr class="line large" /> -->
            <!--         <div class="service-pack">-->
            <!--            <ul class="service-pack__list">-->
            <!--               <li class="service-pack__item">-->
            <!--                  <a class="service-pack__link">-->
            <!--                     <div class="service-pack__images">-->
            <!--                        <img alt="img" src="http://fe-unitel.jones.vn/images/img-style-2.png" />-->
            <!--                     </div>-->
            <!--                  </a>-->
            <!--               </li>-->
            <!--               <li class="service-pack__item">-->
            <!--                  <a class="service-pack__link">-->
            <!--                     <div class="service-pack__images">-->
            <!--                        <img alt="img" src="http://fe-unitel.jones.vn/images/img-style-2.png" />-->
            <!--                     </div>-->
            <!--                  </a>-->
            <!--               </li>-->
            <!--               <li class="service-pack__item">-->
            <!--                  <a class="service-pack__link">-->
            <!--                     <div class="service-pack__images">-->
            <!--                        <img alt="img" src="http://fe-unitel.jones.vn/images/img-style-2.png" />-->
            <!--                     </div>-->
            <!--                  </a>-->
            <!--               </li>-->
            <!--            </ul>-->
            <!--         </div>-->
            <div v-if="lstslideShow && lstslideShow.length > 1" class="list--slide">
               <div v-for="item in lstslideShow.slice(1)" :key="item.id">
                  <template v-if="item.type == 1 && item.images.length > 0">
                     <div class="banner-slider">
                        <ul class="banner-slider__list js-slider-col2">
                           <li v-for="(banner, index) in item.images" :key="index" class="banner-slider__item">
                              <a :href="banner.link" class="service-pack__link">
                                 <img :src="banner.url" alt="img" />
                              </a>
                           </li>
                           <!-- <li class="banner-slider__item"><img src="@/assets/images/banner-home.png" alt="img"></li>
                        <li class="banner-slider__item"><img src="@/assets/images/banner-home.png" alt="img"></li>
                        <li class="banner-slider__item"><img src="@/assets/images/banner-home.png" alt="img"></li>
                        <li class="banner-slider__item"><img src="@/assets/images/banner-home.png" alt="img"></li>
                        <li class="banner-slider__item"><img src="@/assets/images/banner-home.png" alt="img"></li> -->
                        </ul>
                     </div>
                  </template>
                  <template v-if="item.type == 2 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                          <p class="service-pack__des">{{ banner.des }}</p>
                                       </div>
                                       <span class="service-pack__action" @click="onClickFunction(banner.link)"
                                          ><i class="icon-fonts icon-fonts--arrow-right"></i
                                       ></span>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 3 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style3">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                          <p class="service-pack__des">{{ banner.des }}</p>
                                       </div>
                                       <span class="service-pack__action" @click="onClickFunction(banner.link)"
                                          ><i class="icon-fonts icon-fonts--arrow-right"></i
                                       ></span>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 4 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                          <p class="service-pack__des">{{ banner.des }}</p>
                                       </div>
                                       <span class="service-pack__action" @click="onClickFunction(banner.link)"
                                          ><i class="icon-fonts icon-fonts--arrow-right"></i
                                       ></span>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 5 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style5">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                          <p class="service-pack__des">{{ banner.des }}</p>
                                       </div>
                                       <span class="service-pack__action" @click="onClickFunction(banner.link)"
                                          ><i class="icon-fonts icon-fonts--arrow-right"></i
                                       ></span>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 6 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style6">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                       </div>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 7 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                          <p class="service-pack__des">
                                             <span>$</span>
                                             {{ banner.des }}
                                          </p>
                                       </div>
                                       <span class="service-pack__action" @click="onClickFunction(banner.link)"
                                          ><i class="icon-fonts icon-fonts--arrow-right"></i
                                       ></span>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 8 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style8">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__hover">
                                       <p class="service-pack__subdes">{{ banner.title }}</p>
                                       <h5 class="service-pack__subname">{{ banner.des }}</h5>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 9 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style9">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <!-- <h5 class="service-pack__name">IR6</h5><span class="service-pack__data">3Mps</span> -->
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                             <span class="service-pack__data">{{ banner.speed }}</span>
                                          </div>
                                          <p class="service-pack__des">{{ banner.des }}</p>
                                       </div>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 10 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style10">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__hover">
                                       <p class="service-pack__subdes">{{ banner.title }}</p>
                                       <h5 class="service-pack__subname">{{ banner.des }}</h5>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
                  <template v-if="item.type == 11 && item.images.length > 0">
                     <div class="feature-service">
                        <div class="feature-service__top">
                           <h4 class="feature-service__sub">{{ item.title }}</h4>
                           <a :href="item.linkSeeMore" class="feature-service__link">{{ $t('home.noti.see_more') }}</a>
                        </div>
                        <div class="service-pack service-pack--style11">
                           <ul class="service-pack__list">
                              <li v-for="(banner, index) in item.images" :key="index" class="service-pack__item">
                                 <a :href="banner.link" class="service-pack__link">
                                    <div class="service-pack__images">
                                       <img :src="banner.url" alt="img" />
                                    </div>
                                    <div class="service-pack__detail">
                                       <div class="service-pack__info">
                                          <div class="service-pack__top">
                                             <h5 class="service-pack__name">{{ banner.title }}</h5>
                                          </div>
                                          <p class="service-pack__des">{{ banner.des }}</p>
                                       </div>
                                       <span class="service-pack__action" @click="onClickFunction(banner.link)"
                                          ><i class="icon-fonts icon-fonts--arrow-right"></i
                                       ></span>
                                    </div>
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </template>
               </div>
            </div>
         </main-functions>

         <register-pack-flow :data="selectedPack" />
         <ChangeAccountModal @selectedAccount="setSelectedAccount" />
         <!-- <ConfirmModal ref="confirmRef" :notice="conditions" contentStyle="left" :onClose="closeConfirm" /> -->
         <!-- <NoticeKYCModal ref="noticeRef" :notice="notification" contentStyle="center" /> -->
      </div>
   </div>
</template>
<script>
import BaseComponent from '@/mixins/BaseComponent'
import service from './../services/HomeService'
import ftthService from './../../ftth/services/FTTHService'
import {
   AppList,
   Category,
   FavouriteList,
   FTTHFuctionList,
   MobileList,
   ProductUnitelList,
   ChargeType
} from '../constants/data' // import ViewModal from '@/components/modal/ViewModal'
import LocalStorage from '@/ultils/local-storage'
import RegisterPackFlow from '../../mobile/components/common/RegisterPackFlow'
import $ from 'jquery'
import { callNative } from '@/ultils/call-native'
import ChangeAccountModal from './ChangeAccountModal.vue'
import store from '@/plugins/vuex/store'
import FtthStorage from '@/ultils/ftth-storage'
import { sha256 } from 'js-sha256'
import MainFunctions from '@/modules/home/components/MainFunctions.vue'
import HomeNavbar from '@/modules/home/components/HomeNavbar.vue'
import HomeAccountData from '@/modules/home/components/HomeAccountData.vue'
import HomeFtthData from '@/modules/home/components/HomeFtthData.vue'
// import ConfirmModal from "@/components/modal/ConfirmModal.vue"
// import NoticeKYCModal from '@/components/modal/noticeModal.vue'
import IconWarn from '@/assets/images/ic-warning.svg'
export default {
   name: 'HomeAuthenticated',
   mixins: [BaseComponent],
   components: {
      HomeFtthData,
      HomeAccountData,
      HomeNavbar,
      MainFunctions,
      // ViewModal
      RegisterPackFlow,
      ChangeAccountModal
      // ConfirmModal,
      // NoticeKYCModal
   },
   data() {
      return {
         ftthTab: 0,
         banners: [],
         user: {
            name: '',
            rank: '',
            availabelUpoint: 0,
            expDate: '',
            avatarUrl: '',
            status: -1,
            phone: '',
            avatar: ''
         },
         favouriteList: [],
         appList: AppList,
         view: {
            name: '',
            url: ''
         },
         lstNoti: [],
         isCheckCH: false,
         isCheckData: false,
         isCheckBalance: false,
         accountInfo: {},
         lstCurrentUsedSubServices: [],
         lstServiceBestSeller: [],
         selectedPack: {},
         lstslideShow: [],
         subType: 1,
         mobileList: MobileList,
         productUnitel: ProductUnitelList,
         ftthList: FTTHFuctionList,
         isShowLinkFTTH: false,
         isShowAccountInfo: false,
         conditions: {
            title: 'Điều kiện chuyển đổi eSIM',
            content: [
               'eSIM conversion is only available for numbers logged into Myunitel. It cannot be registered for other numbers.',
               'Before converting to eSIM, please back up your contacts and password in Myunitel.',
               'After Unitel approves, your physical phone number will no longer be usable.',
               'Please use another physical SIM or connect to Wi-Fi to access the eSIM conversion section on Myunitel, obtain the eSIM QR code, and follow the instructions to complete the eSIM installation.'
            ],
            closeButton: 'Tiếp theo'
         },
         notification: {
            content:
               '<p>Số điện thoại chưa thực hiện eKYC.<br/>Vui lòng thực hiện eKYC trước khi chuyển qua bước tiếp theo </p>',
            icon: IconWarn,
            closeButton: 'Click để thực hiện eKYC'
         },
         isLoggedIn: false,
         newAccountFTTH: false,
         addAccountFTTH: false
      }
   },
   async created() {
      this.setTitle(this.$i18n.t('home.logined.tab_title'))
      this.UserInfo = JSON.parse(LocalStorage.getItem('user_info') || '{}')
      await this.loadData()
      // this.checkLogin()
      // await this.onClickFTTHTab()
      // this.checkParams()
      const tab = this.$route.query.tab
      if (tab === 'ftth') {
         this.activeTab = 'ftth'
         this.newAccountFTTH = false 
         this.addAccountFTTH = false
         setTimeout(() => {
            this.onClickFTTHTab()
         }, 100)
      }
   },
   mounted() {
      this.heightMainContent()
      // this.checkLogin()
   },

   computed: {
      isLinkedFTTH() {
         const list = this.$store.state.linkedFtthAccountList
         if (list === null) return null // Chưa biết
         return list.length > 0
      },
      selectedFTTHAccount() {
         return this.$store.state.ftthAccountNo
      },
      activeFTTH() {
         return this.$store.state.activeFTTH
      }
   },
   methods: {
      sha256,
      cycle(prepaidCode) {
         const inputString = prepaidCode + ''
         const matches = inputString.match(/_(.*?)_/)
         if (matches !== null && matches[1] !== null) {
            return matches[1].replace('M', '').replace('m', '')
         } else {
            return ''
         }
      },
      onClickTab(index) {
         console.log('onClickTab', index)

         this.ftthTab = index
         let currentAccount =
            this.$store.state?.linkedFtthAccountList[index]?.accountNo ||
            this.$store.state?.linkedFtthAccountList[index]?.account
         //accountNo là API cũ api mới sài account
         let ftthUserInfo = {
            token: '',
            isdn: currentAccount,
            sessionId: ''
         }
         console.log('this.$store.state?.linkedFtthAccountList[index]', this.$store.state?.linkedFtthAccountList[index])
         LocalStorage.setItem('ftth_account_info', JSON.stringify(this.$store.state?.linkedFtthAccountList[index]))
         LocalStorage.setItem('ftth_user_info', JSON.stringify(ftthUserInfo))
         console.log('currentAccount', currentAccount)
         LocalStorage.setItem('ftth_account', currentAccount)
      },

      handleAuthen() {
         // Force reactive lại nếu đang dùng localStorage ở đây
         this.isLoggedIn = !!JSON.parse(localStorage.getItem('ftth_user_info'))?.token
      },

      onClickMobileTab() {
         this.$store.commit('setActiveTabFTTH', false)
         console.log('onClickMobileTab')
      },
      async onClickFTTHTab() {
         console.log('onClickFTTHTab')
         this.$store.commit('setActiveTabFTTH', true)
         console.log('newAccountsFTTH',this.newAccountFTTH)
         var addAccount = LocalStorage.getItem('add_account_ftth') ?? false
         //Lấy đk tài khoải mới login
         const justLoggedIn = localStorage.getItem('just_logged_in')
         console.log('justLoggedIn',justLoggedIn)
         if (!this.isLinkedFTTH || !this.newAccountFTTH) {
            // if (false) {
            console.log('isLinkedFTTH ' + this.isLinkedFTTH)
            var ftthData = JSON.parse(FtthStorage.getFtthAccount()) ?? []
            console.log('ftthData ' + ftthData)
            if (addAccount || justLoggedIn) {
               // if (false) {
               if (ftthData.length > 0) {
                  this.$store.state.linkedFtthAccountList = ftthData
                  this.$store.state.ftthAccountNo = ftthData[0]?.account
               } else {
                  this.$store.state.linkedFtthAccountList = []
               }
               console.log('ftthData1' + JSON.stringify(ftthData))
               this.$store.state.activeFTTH = true
               if(justLoggedIn === 'true') {
                     // this.getListAccountMyUnitel()
               }
            } else {
               this.showLoading()
               // service
               //    .getListFtthAccountInfo()
               //    .then((response) => {
               //       FtthStorage.addAccount(JSON.stringify(response.wsResponse ?? []))
               //       ftthData = JSON.parse(FtthStorage.getFtthAccount()) ?? []
               //       this.$store.state.linkedFtthAccountList = ftthData
               //       this.$store.state.ftthAccountNo = ftthData[0]?.accountNo
               //    })
               //    .finally(() => {
               //       this.hideLoading()
               //    })
               await ftthService
                  .getFtthAccountSameCust({})
                  .then(async (response) => {
                     console.log('response8239', response)
                     FtthStorage.addAccount(JSON.stringify(response.wsResponse?.data ?? []))
                     this.$store.state.linkedFtthAccountList = response.wsResponse?.data ?? []
                     this.$store.state.ftthAccountNo = response.wsResponse?.data[0]
                     console.log(
                        'this.$store.state?.linkedFtthAccountList[0]',
                        JSON.stringify(this.$store.state?.linkedFtthAccountList[0])
                     )
                     if (response && response?.wsResponse?.data[0]) {
                        await LocalStorage.setItem('ftth_account_info', JSON.stringify(response.wsResponse?.data[0]))

                        console.log(
                           'this.$store.state?.linkedFtthAccountList[0]?.account',
                           response.wsResponse?.data[0]?.account
                        )
                        const ftth_account_current = response.wsResponse?.data[0]?.account + ''
                        // const ftthUserInfo = {
                        //    token: '',
                        //    isdn: ftth_account_current,
                        //    sessionId: ''
                        // }
                        await LocalStorage.setItem('ftth_user_info', JSON.stringify(ftthUserInfo))
                        await LocalStorage.setItem('ftth_account', ftth_account_current)
                     }
                  })
                  .finally(() => {
                     this.hideLoading()
                     // this.getListAccountMyUnitel()
                  })
            }
         } else {
            // this.$store.state.ftthAccountNo = FtthStorage.getFtthAccount()[0]?.accountNo
            this.$store.state.ftthAccountNo = this.$store.state?.linkedFtthAccountList[0]?.account
            const ftthAccountList = this.$store.state?.linkedFtthAccountList
         }
         var ftthDataNew = JSON.parse(FtthStorage.getFtthAccount()) ?? []
         const hash = window.location.hash // "#/home?originalUrl=#/ftth/payment-ftth"
         const queryString = hash.split('?')[1] // "originalUrl=#/ftth/payment-ftth"

         let redirectUrl = null
         if (queryString) {
            if (ftthDataNew.length < 2) {
               const params = new URLSearchParams(queryString)
               redirectUrl = params.get('redirectUrl') // "#/ftth/payment-ftth"
               this.$router.push(redirectUrl)
            } else {
               this.$router.push('/home')
            }
         }
         LocalStorage.setItem('add_account_ftth', false)
      },
      async getListAccountMyUnitel() {
         this.showLoading()

         try {
            const response = await ftthService.wsGetListAccountMyUnitel({
               isdn: this.userInfo?.isdn,
               accountFtth: this.account
            })

            if (response.errorCode === '0' || response.errorCode === '200') {
               const newAccounts = Array.isArray(response?.wsResponse) ? response.wsResponse : []

               // Lấy danh sách account hiện tại trong localStorage
               const localData = JSON.parse(localStorage.getItem('key_ftth_data')) || []

               // Format dữ liệu mới
               const formattedList = newAccounts.map((account) => {
                  const formattedAccount = {
                     ...account,
                     account: account.accountFtth,
                     prodPackageCode: account.packageName,
                     prodPackagePrice: account.packagePrice
                  }
                  delete formattedAccount.accountFtth
                  return formattedAccount
               })

               // Gộp và loại trùng
               const updatedData = [...localData]
               formattedList.forEach((acc) => {
                  const isDuplicate = updatedData.some((item) => item.account === acc.account)
                  if (!isDuplicate) {
                     updatedData.push(acc)
                  }
               })

               console.log(updatedData)
               // Lưu vào store 1 lần duy nhất
               this.$store.state.linkedFtthAccountList = updatedData

               // Lưu vào localStorage
               localStorage.setItem('just_logged_in', false)
               localStorage.setItem('ftth_account_info', JSON.stringify(updatedData[0]))
               localStorage.setItem('key_ftth_data', JSON.stringify(updatedData))
   
            } else {
               this.errorMessage = 'response.userMsg'
            }
         } catch (error) {
            console.error('Lỗi khi gọi getFtthAccountSameCust:', error)
         } finally {
            setTimeout(() => {
               this.hideLoading()
            }, 1400)
         }
      },
      async onClickFunction(url) {
         this.$router.push(url)
      },
      selectPack(pack) {
         this.selectedPack = Object.assign({}, pack)
      },
      borrowData() {
         if (this.subType == 1) {
            this.$router.push(`/mobile/credit-service?tab=data&title=${this.$t('home.noti.borrow_data')}`)
         } else {
            this.$router.push(`/mobile/data-package?title=${this.$t('home.noti.borrow_data')}`)
         }
      },
      redirectMobileRecharge() {
         this.$router.push(`/mobile/recharge?title=${this.$t('home.functions.recharge')}`)
      },
      redirectMobileBorrow() {
         if (this.subType == 1) {
            this.$router.push(`/mobile/credit-service?title=${this.$t('home.noti.borrow')}`)
         } else {
            this.$router.push(`/mobile/data-package?title=${this.$t('home.noti.borrow')}`)
         }
      },
      deleteNoti(type) {
         this.lstNoti.map((x) => {
            if (x.type == 'DATA' && x.type == type) {
               x.isDeleteData = false
            }
            if (x.type == 'BALANCE' && x.type == type) {
               x.isDeleteBalance = false
            }
            if (x.type == '3GRAB' && x.type == type) {
               x.isDeleteCH = false
            }
         })
         console.log('this.lstNoti', this.lstNoti)
         this.$forceUpdate()
      },

      async getSubAccountInfo() {
         if (!LocalStorage.getItem('subType')) await loadUserInfo
         this.subType = LocalStorage.getItem('subType')
         this.showLoading()
         service
            .GetSubAccountInfo({ subType: this.subType })
            .then((response) => {
               // this.accountInfo = response.wsResponse ?? {}
               let data = response.wsResponse
               this.accountInfo = data
                  ? {
                       prePost: data.prePost ?? 0,
                       debPost: data.debPost ?? 0,
                       mainAcc: data.mainAcc ?? 0,
                       proAcc: data.proAcc ?? 0,
                       dataPkgName: data.name,
                       dataVolume: data.dataVolume
                    }
                  : {}
            })
            .finally(() => {
               this.hideLoading()
            })
      },

      async loadData() {
         this.showLoading()
         this.favouriteList =
            JSON.parse(LocalStorage.getItem('favourite_list_2204_' + LocalStorage.getItem('lang'))) ?? FavouriteList
         let loadUserInfo = service.getUserInfo().then((response) => {
            this.user.name = response.wsResponse?.name || ''
            this.user.status =
               response.wsResponse?.standardStatus === '1' && response.wsResponse?.standardSystem === '3GRAB'
                  ? response.wsResponse.standardStatus || 0
                  : 0
            this.user.avatarUrl = response.wsResponse?.avatar_url?.trim() || ''
            this.user.avatar = response.wsResponse?.avatar?.trim() || ''

            LocalStorage.setItem('subType', response.wsResponse.subType)
            let userInfo = JSON.parse(LocalStorage.getItem('user_info')) ?? {}
            this.user.phone = userInfo['isdn'] ?? ''
            this.favouriteList = this.favouriteList.filter(
               (func) =>
                  func.chargeType === response.wsResponse.subType ||
                  func.chargeType === ChargeType.Both ||
                  func.chargeType == null
            )
            LocalStorage.setItem(
               'favourite_list_2204_' + LocalStorage.getItem('lang'),
               JSON.stringify(this.favouriteList)
            )
            LocalStorage.setItem('user_detail', JSON.stringify(response.wsResponse))
            
            // clear ftth neu load moi
            // LocalStorage.removeItem("key_ftth_data")
            // LocalStorage.removeItem("ftth_account")
            // LocalStorage.removeItem("ftth_account_info")
            // LocalStorage.removeItem("ftth_user_info")
            // LocalStorage.removeItem("add_account_ftth")
            // this.$store.state.linkedFtthAccountList = []
         })
         // let loadRank = await service.getRank().then((response) => {
         //    this.user.rank = response.accountRankDTO?.rankName ?? ''
         //    this.user.expDate =
         //       this.user.rank === 'Loyal'
         //          ? 'Unlimited'
         //          : response.accountRankDTO?.endDate.substring(0, 10).split('-').reverse().join('/') ?? ''
         // })
         // let loadAvalableUpoint = await service.getAvailableUpoint().then((response) => {
         //    this.user.availabelUpoint = (response.listAccountPoint ?? []).reduce((total, accPoint) => {
         //       if (accPoint.pointType == 2) return total + accPoint.pointValue
         //       else return total
         //    }, 0)
         // })
         //  await service.getListBanners({ limit: 5 }).then((response) => {
         //     this.banners = response.wsResponse
         //     if (this.banners.length > 0) {
         //        $(".js-slider-col1").css("display", "none")
         //           $.getScript('js/slider.js', () => {
         //               $(".js-slider-col1").css("display", "block")
         //           })
         //     }
         //  })
         let userDetail = JSON.parse(LocalStorage.getItem('user_info')) ?? {}
         let isdn = userDetail.isdn
         // let getNoticeWebview = service.GetNoticeWebview({ isdn: isdn }).then((response) => {
         //    this.lstNoti = response.object ?? []
         // })
         // == 1 trả trước, ==2 trả sau

         await Promise.allSettled([loadUserInfo]).finally(() => {})
         // if(!LocalStorage.getItem('subType')) await loadUserInfo; // đoạn này merge code
         // this.subType = LocalStorage.getItem('subType')
         // let getSubAccountInfo = service.GetSubAccountInfo({ subType: this.subType || 1 }).then((response) => {
         //    // this.accountInfo = response.wsResponse ?? {}
         //    let data = response.wsResponse
         //    this.accountInfo = data
         //       ? {
         //            prePost: data.prePost ?? 0,
         //            debPost: data.debPost ?? 0,
         //            mainAcc: data.mainAcc ?? 0,
         //            proAcc: data.proAcc ?? 0,
         //            dataPkgName: data.name,
         //            dataVolume: data.dataVolume
         //         }
         //       : {}
         // })
         // await Promise.allSettled([loadUserInfo, getNoticeWebview, getSubAccountInfo]).finally(() => {})
         this.isCheckData = false
         this.isCheckCH = false
         this.isCheckBalance = false
         // binhvt
         let isCurrentUsedSubServices = false
         if (this.lstNoti && this.lstNoti.length != 0 && this.accountInfo) {
            let dataVolume = this.accountInfo.dataVolume ? parseInt(this.accountInfo.dataVolume) : 0
            let mainAcc = this.accountInfo.mainAcc ? parseInt(this.accountInfo.mainAcc) : 0
            let debPost = this.accountInfo.debPost ? parseInt(this.accountInfo.debPost) : 0
            let _this = this
            this.lstNoti.map((x) => {
               // binhvt test default true, upcode default false
               x.isDeleteData = false
               x.isDeleteBalance = false
               x.isDeleteCH = false
            })
            this.lstNoti.map((x) => {
               if (x.type == 'DATA' && parseInt(x.value) > dataVolume) {
                  x.isDeleteData = true
                  isCurrentUsedSubServices = true
               }
               if (x.type == 'BALANCE') {
                  // == 1 trả trước, ==2 trả sau
                  if (this.subType == 1 && parseInt(x.value) > mainAcc) {
                     x.isDeleteBalance = true
                  }
                  if (this.subType == 2 && parseInt(x.value) > debPost) {
                     x.isDeleteBalance = true
                  }
               }
               if (x.type == '3GRAB' && parseInt(_this.user.status) != 1) {
                  x.isDeleteCH = true
               }
            })
            console.log('this.lstNoti', this.lstNoti)

            if (isCurrentUsedSubServices) {
               service.GetCurrentUsedSubServices({ isdn: isdn }).then((response) => {
                  this.lstCurrentUsedSubServices = response.wsResponse ?? []
               })

               service.GetServiceBestSeller({ isdn: isdn }).then((response) => {
                  this.lstServiceBestSeller = response.object ?? []
               })
            }
         }
         console.log('lstServiceBestSeller', this.lstServiceBestSeller)

         // try {
         //    await service.GetBannerWebview().then((response) => {
         //       // this.lstslideShow = response.object.sort(function (a, b) {
         //       //       return b.type - a.type;
         //       //    }) ?? []
         //       this.lstslideShow = response.object
         //    })
         // } catch (error) {
         //    this.hideLoading()
         // }

         console.log('this.lstslideShow', this.lstslideShow)
         this.$forceUpdate()
         if (this.lstslideShow && this.lstslideShow.length != 0) {
            $('.js-slider-col2').css('display', 'none')
            $.getScript('js/slider.js', () => {
               $('.js-slider-col2').css('display', 'block')
            })
         }
         // if (!this.isLinkedFTTH) {
         //    console.log('isLinkedFTTH ' + this.isLinkedFTTH)
         //    this.showLoading()
         //    service
         //       .getListFtthAccountInfo()
         //       .then((response) => {
         //          this.$store.state.linkedFtthAccountList = response.wsResponse ?? []
         //          this.$store.state.ftthAccountNo = this.$store.state?.linkedFtthAccountList[0]?.accountNo
         //       })
         //       .finally(() => {
         //          this.hideLoading()
         //       })
         // } else {
         //    this.$store.state.ftthAccountNo = this.$store.state?.linkedFtthAccountList[0]?.accountNo
         // }
         this.hideLoading()
      },
      setViewModal(name, url) {
         this.view = { name, url }
      },
      redirectToByVal(status) {
         if (parseInt(status) == 1) {
            this.$router.push('/mobile/info?tab=user')
         } else {
            this.$router.push('/laokyc')
         }
      },
      redirectTo(url) {
         this.$router.push(url)
      },
      async redirectToApp(app) {
         let installLaoApp = false // debug
         // this.showLoading()
         // installLaoApp = await service.GetLaoAppStatus().then((response)=>{
         //   this.hideLoading()
         //   if (response.errorCode === '0') {
         //       let status = response.wsResponse.status
         //       if(status >= 2){
         //         return true;
         //       }
         //   }
         // })
         // .catch(() => {
         //        this.hideLoading()
         // })
         let appCode = LocalStorage.getItem('appCode')
         if (installLaoApp) {
            window.open(app.deepLink, '_blank')
         } else {
            if (app.url.includes('http') || app.url.includes('mocha:')) {
               // window.open(app.url)
               callNative(app.callNative, '')
            } else {
               if (app.name === this.$i18n.t('home.apps.internet_services') && !appCode) {
                  this.getListFtthAccountInfo()
               } else {
                  if (appCode === 'LaoApp') {
                     window.open(app.deepLink)
                  } else {
                     this.$router.push(app.url)
                  }
               }
            }
         }
         // test deeplink
         //  if (app.isDeepLink) {
         //   // check install Lao app
         //   let installLaoApp= true
         //   if(installLaoApp){
         //     window.open(app.deepLink)
         //   }else {
         //     this.$router.push(app.url)
         //   }
         //  }
         //  else if (app.name === this.$i18n.t('home.apps.internet_services')) {
         //     this.getListFtthAccountInfo()
         //  } else {
         //     this.$router.push(app.url)
         //  }
      },
      async redirectToFunc(func) {
         let appCode = LocalStorage.getItem('appCode')
         if (func.category === Category.InternetService) {
            LocalStorage.setItem('ftth_redirect_url', func.url)
            this.$router.push('/ftth/login')
         } else if (
            (func.url.includes('mocha:') || func.url.includes('laoapp.la') || func.url.includes('unitel.com.la')) &&
            !appCode
         ) {
            window.open(func.url)
         } else if (func.deepLink) {
            let installLaoApp = false // debug
            // this.showLoading()
            // installLaoApp = await service.GetLaoAppStatus().then((response)=>{
            //   this.hideLoading()
            //   if (response.errorCode === '0') {
            //       let status = response.wsResponse.status
            //       if(status >= 2){
            //         return true;
            //       }
            //   }
            // })
            // .catch(() => {
            //       this.hideLoading()
            // })
            if (installLaoApp) {
               window.open(func.deepLink)
            } else {
               let appCode = LocalStorage.getItem('appCode')
               if (appCode === 'LaoApp') {
                  window.open(func.deepLink)
               } else {
                  this.$router.push(func.url)
               }
            }
         } else {
            this.$router.push(func.url)
         }
      },
      async redirectToMobileFunc(func) {
         switch (func.url) {
            case '/mobile/change_sim_3g_4g': {
               callNative('open_change_sim_3g_4g', '')
               break
            }
            case '/mobile/change_esim': {
               // this.$store.dispatch('setNotification', { content: this.$t('warning_esim') })
               this.$refs.confirmRef.showModal()

               // const userInfo = JSON.parse(LocalStorage.getItem('user_detail')) || {}
               // if(userInfo.standardStatus == 1 && ['EKYC', 'EKYC_SYSTEM'].includes(userInfo.standardSystem)) {
               //    this.$refs.confirmRef.showModal()
               // }else {
               //     this.$refs.noticeRef.showModal()
               // }
               break
            }
            case '/mobile/map/by-current-location': {
               // callNative('open_unitel_shop', '')
               this.$router.push('/mobile/map/by-current-location')
               break
            }
            case '/mobile/umoney': {
               callNative('open_umoney', '')
               break
            }
            case '/mobile/change_to_postpaid': {
               if (this.subType == 1) {
                  // tra truoc
                  this.$router.push('/mobile/change_to_postpaid')
               } else {
                  this.$router.push('/mobile/change-to-prepaid/customer-info')
               }
               break
            }
            default:
               this.$router.push(func.url)
         }
      },
      redirectToFuncFtth(func) {
         if (func.name === this.$i18n.t('home.functions.pay_monthly_fee')) {
            callNative('open_pay_monthly_fee', LocalStorage.getItem('ftth_account'))
         } else if (func.name === this.$i18n.t('home.functions.speedtest')) {
            window.open(func.url)
            // } else if (func.name === this.$i18n.t('home.functions.report_error')) {
            //    callNative('open_report_error', LocalStorage.getItem('ftth_account'))
            // this.$router.push(func.url)
            //} else if (func.name === this.$i18n.t('home.functions.add_100_call_minutes')) {
            //   callNative('open_add100', '')
         } else if (func.name === this.$i18n.t('home.functions.promotion_info')) {
            callNative('open_promotion_info', LocalStorage.getItem('ftth_account'))
         } else if (func.name === this.$i18n.t('ucare.title')) {
            LocalStorage.setItem('click_ucare_ftth', true)
            this.$router.push(func.url)
         } else if (func.name === this.$i18n.t('home.functions.change_product')) {
            let step1 = {
               newProductCode: '',
               newSubType: '',
               listPackage: [],
               listSubType: []
            }
            let step3 = {
               transId: '',
               timestamp: '',
               transDate: '',
               serviceCode: '',
               account: ''
            }
            store.commit('setStep1', step1)
            store.commit('setStep3', step3)
            this.$router.push(func.url)
         } else if (func.url === 'saleman') {
            window.open(
               'https://saleman.unitel.com.la:8680/follow-order-ftth?msisdn=' +
                  this.user.phone +
                  '&language=' +
                  LocalStorage.getItem('lang')
            )
         } else {
            this.$router.push(func.url)
         }
      },
      getListFtthAccountInfo() {
         this.showLoading()
         service
            .getListFtthAccountInfo()
            .then((response) => {
               if (response.errorCode === '0') {
                  let result = response.wsResponse ?? []
                  if (result.length > 0) {
                     this.$router.push('/ftth/account-list')
                  } else {
                     this.$router.push('/ftth/login')
                  }
               } else {
                  this.$store.dispatch('setNotification', { content: response.message ?? response.userMsg })
                  this.hideLoading()
               }
            })
            .catch(() => {
               this.hideLoading()
            })
      },
      setSelectedAccount(value) {
         this.$store.state.ftthAccountNo = value
      },
      authen() {
         LocalStorage.setItem('add_account_ftth', true)
         // let appCode = LocalStorage.getItem('appCode')
         callNative('login', '')
         console.log('host: ' + window.location.host)
         let host = window.location.origin
         let redirectUri = host + encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)
         let clientId = process.env.VUE_APP_CLIENT_ID
         // let step = 'identifier'
         let useCallback = true
         let url = process.env.VUE_APP_LOGIN_URL
         // window.location.href = `${url}?redirectUri=${redirectUri}&clientId=${clientId}&step=${step}&isFromWeb=${isFromWeb}`
         // window.location.href = `${url}?redirect_uri=${redirectUri}&client_id=${clientId}&use_callback_uri=${useCallback}`
         // if (appCode === 'LaoApp') {
         //    window.open('mocha://loginapp')
         // } else {
         //    callNative('login', '')
         //    console.log('host: ' + window.location.host)
         //    let host = window.location.origin
         //    let redirectUri = host + encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)
         //    let clientId = process.env.VUE_APP_CLIENT_ID
         //    let step = 'identifier'
         //    let isFromWeb = true
         //    let url = process.env.VUE_APP_LOGIN_URL
         //    window.location.href = `${url}?redirectUri=${redirectUri}&clientId=${clientId}&step=${step}&isFromWeb=${isFromWeb}`
         // }
      },
      async onPay(ftthAccount) {
         console.log('ftthAccount', ftthAccount)
         LocalStorage.setItem('dataAccountFtth', JSON.stringify(ftthAccount))
         // this.$router.push('/ftth/pay-bill')
         this.$router.push('/ftth/renew-prepaid')
      },
      handleLoadAccountInfo(val) {
         console.log('load', val)
         this.isShowAccountInfo = val
         if (val) this.getSubAccountInfo()
      },
      heightMainContent() {
         const navBar = document.querySelector('#nav-bar')

         if (navBar) {
            this.$refs.homeContent.style.height = `calc(100dvh - ${navBar.offsetHeight}px)`
            this.$refs.homeContent.style.overflowY = `scroll`
         }
      },

      closeConfirm() {
         this.$router.push('/mobile/change-esim')
      }
   }
}
</script>

<style lang="scss" scoped>
.noti-new__detail {
   display: block;
}

.main-container {
   padding: 0;
   margin: 0;

   &:after {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100%;

      background: linear-gradient(204deg, #fc9d00 0%, #f56e22 19%, #c52305 48%);
      z-index: -1;
   }

   .bg-home {
      position: fixed;
      z-index: 0;
      top: 87px;
      right: 0;
      mix-blend-mode: screen;
   }

   .noti-custom {
      margin: 20px;
      padding: 20px;
      border-radius: 20px;

      &__action {
         top: 20px;
         right: 20px;
      }
   }

   .line {
      margin: 25px 20px;

      &.large {
         margin-top: 30px;
      }
   }

   .service-pack {
      &__list {
         width: 100%;
         padding: 0 20px;
         margin: 0;
         gap: 10px;
      }

      &__item {
         margin: 0;
         border-radius: 10px;
      }
   }

   .list--slide {
      padding: 0 20px;

      .service-pack__list {
         padding: 0;
      }
   }
}
//transition for main account
.bounce-enter-active {
   animation: bounce-in 1.6s;
}
.bounce-leave-active {
   animation: bounce-in 1.6s reverse;
}
@keyframes bounce-in {
   0% {
      transform: scale(0);
   }
   50% {
      transform: scale(1.1);
   }
   100% {
      transform: scale(1);
   }
}

// new animation fade in/out
.fade-enter-active {
   animation: fade-in 1.6s;
}
.fade-leave-active {
   animation: fade-out 1.6s;
}
@keyframes fade-in {
   0% {
      opacity: 0;
      transform: scale(0.9); /* Tùy chọn: hiệu ứng nhỏ lại rồi xuất hiện */
   }
   100% {
      opacity: 1;
      transform: scale(1);
   }
}
@keyframes fade-out {
   0% {
      opacity: 1;
      transform: scale(1);
   }
   100% {
      opacity: 0;
      transform: scale(0.9); /* Tùy chọn: thu nhỏ dần */
   }
}

// animation slide
.slide-enter-active {
   animation: slide-in 0.6s ease-out;
}
.slide-leave-active {
   animation: slide-out 0.6s ease-out;
}

@keyframes slide-in {
   0% {
      transform: translateX(100%);
      opacity: 0;
   }
   100% {
      transform: translateX(0);
      opacity: 1;
   }
}

@keyframes slide-out {
   0% {
      transform: translateX(0);
      opacity: 1;
   }
   100% {
      transform: translateX(-100%);
      opacity: 0;
   }
}
</style>
